// mv-slider
const swiper = new Swiper(".mv-swiper", {
  slidesPerView: 1,
  speed: 1800,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    390: {
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: true,
    },
    787: {
      slidesPerView: 1.3,
      spaceBetween: 20,
      centeredSlides: true,
    },
    1600: {
      slidesPerView: 1.7,
      spaceBetween: 40,
      centeredSlides: true,
    }
  }
});



// top-pickup-swiper
const pickupSwiper = new Swiper(".pickup-swiper", {
  loop: false,
  spaceBetween: 8,
  slidesPerView: 1.5,
  grid: {
    rows: 2,
    fill: 'row'
  },
  breakpoints: {
    788: {
      slidesPerView: 1,
      grid: {
        rows: 1
      },
      spaceBetween: 15,
    }
  }
});



//top-ranking tab
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('nav.ranking__nav a');
  const panels = document.querySelectorAll('ul.panel>li');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      // Remove 'on' class from all tabs
      tabs.forEach(tab => tab.classList.remove('on'));

      // Add 'on' class to the clicked tab
      tab.classList.add('on');

      // Remove 'on' class from all panels
      panels.forEach(panel => panel.classList.remove('on'));

      // Add 'on' class to the corresponding panel
      panels[index].classList.add('on');
    });
  });
});



//top-recommend
const recommendSwiper = new Swiper(".recommend-product", {
  loop: true,
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next.swiper-button-next--recommend",
    prevEl: ".swiper-button-prev.swiper-button-prev--recommend",
  },
  slidesPerView: 3,
  slidesPerGroup: 3,
  breakpoints: {
    788: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    }
  },
  on: {
    init: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--recommend");
    },
    slideChange: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--recommend");
    }
  }
});

function togglePrevButton(swiper, prevButtonSelector) {
  const prevButton = document.querySelector(prevButtonSelector);
  if (swiper.realIndex === 0) {
    prevButton.style.display = "none";
  } else {
    prevButton.style.display = "";
  }
}



//top-product
const productSwiper = new Swiper(".list-product", {
  loop: true,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper-button-next.swiper-button-next--products",
    prevEl: ".swiper-button-prev.swiper-button-prev--products",
  },
  slidesPerView: 3,
  slidesPerGroup: 3,
  breakpoints: {
    788: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    }
  },
  on: {
    init: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--products");
    },
    slideChange: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--products");
    }
  }
});


// //top-banner
const bannerswiper = new Swiper('.js-bannerSwiper', {
  loop: true,
  slidesPerView: 1.5,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


//top-new
document.querySelectorAll(".new-product").forEach(function(el) {
  const section = el.closest(".top-new");
  new Swiper(el, {
    spaceBetween: 15,
    pagination: {
      el: section.querySelector(".swiper-pagination.swiper-pagination--new"),
      clickable: true,
    },
    navigation: {
      nextEl: section.querySelector(".swiper-button-next.swiper-button-next--new"),
      prevEl: section.querySelector(".swiper-button-prev.swiper-button-prev--new"),
    },
    slidesPerView: 3,
    slidesPerGroup: 3,
    freeMode: true,
    breakpoints: {
      390: {
        slidesPerView: 2.3,
        slidesPerGroup: 2,
      },
      788: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      }
    }
  });
});


//top-outlet
const outletSwiper = new Swiper(".outlet-product", {
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination.swiper-pagination--outlet",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next.swiper-button-next--outlet",
    prevEl: ".swiper-button-prev.swiper-button-prev--outlet",
  },
  slidesPerView: 3,
  slidesPerGroup: 3,
  freeMode: true,
  breakpoints: {
    390: {
      slidesPerView: 2.3,
      slidesPerGroup: 2,
    },
    788: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    }
  }
});

//ranking
if (window.innerWidth <= 787) {
  document.querySelectorAll('.products-wrapper.swiper').forEach(function(el, i) {
    new Swiper(el, {
      slidesPerView: 2.3,
      slidesPerGroup: 2,
      spaceBetween: 4,
      loop: false,
      freeMode: true,
      slidesOffsetAfter: el.querySelectorAll('.swiper-slide').length > 2 ? el.offsetWidth * 0.3 : 0
    });
  });
}